import Vue from 'vue/dist/vue.esm'
import template from './district_all_objectives_report_template.slim'
import chartResponsiveWidth from '../../mixins/chart_responsive_width'
import chartFilterable from '../../mixins/chart_filterable'

const LABELS = ["Not Yet", "Somewhat", "Mostly", "Yes", "Exemplary"];
const SERIES = [4, 3, 2, 1, 0, ""];
const scoreToLabel = ([score, _count]) => {
  return LABELS[score] || window.scorePhrase("no_score", "No Score");
};

const NO_SCORE_COLOR = "#D1D8E3";
const DEFAULT_SCORE_COLORS = {
  4: "#2573D9",
  3: "#0F9200",
  2: "#52C94B",
  1: "#FCD34D",
  0: "#F78154"
};

Vue.component('district_all_objectives_report', {
  mixins: [template, chartResponsiveWidth, chartFilterable],
  props: ['score_colors_and_fills', 'school_year_label', 'year_info', 'report_date', 'section'],
  data() {
    const colors = SERIES.map((score) => {
      if (score === "") return NO_SCORE_COLOR;
      return (this.score_colors_and_fills && this.score_colors_and_fills[score] && this.score_colors_and_fills[score].color) || DEFAULT_SCORE_COLORS[score];
    });

    return {
      series: [],
      currentFilterType: 'whole_year',
      chartData: { week: {}, month: {}, year: {}, range: {} },
      chartOptions: {
        chart: {
          type: 'donut',
        },
        dataLabels: {
          enabled: false
        },
        fill: {
          colors
        },
        legend: {
          markers: {
            fillColors: colors
          }
        }
      }
    }
  },
  mounted() {
      this.wholeYearRangeClicked();
      this.updateDataAttributes();
  },
  watch: {
    currentFilterType: 'updateDataAttributes'
  },
  methods: {
    sortedData: function(range) {
      return SERIES.map((score) => {
        return [score, this.chartData[range][score] || 0];
      })
    },
    chart: function() {
      return this.$refs.allScoresApexChart;
    },
    update: function(range) {
      const data = this.sortedData(range);
      const series = _.map(data, 1);
      const labels = _.map(data, scoreToLabel);

      this.chart()?.updateSeries(series);
      this.chart()?.updateOptions({labels});
    },
    sevenDayRangeClicked: function() {
      this.update("week");
      this.currentFilterType = '7_days';
    },
    thirtyDayRangeClicked: function() {
      this.update("month");
      this.currentFilterType = '30_days';
    },
    wholeYearRangeClicked: function() {
      this.update("year");
      this.currentFilterType = 'whole_year';
    },
    updateDataAttributes: function () {
      const el = this.$el;
      if (!el) return;

      el.setAttribute('data-filter-type', this.currentFilterType);
    },
    applyData: function(data) {
      this.chartData = data;
      const range = this.filters.dateRange ? 'range' : { '7_days': 'week', '30_days': 'month', 'whole_year': 'year' }[this.currentFilterType];
      this.update(range);
    }
  }
})
